<template>
  <el-row class="index-main">
    <el-row class="yujing">
      <el-row>
        <span style="font-size: 20px; color: #888888">预警提醒</span>
      </el-row>
      <el-row style="margin-top: 35px">
        <ul class="my-ul">
          <!-- 抢单竞价表我发出的--竞价-进行中 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/goods/send-rush-bidding-list?status=PROCEED',
                'QIANGDANJINGJIABIAO_WOFACHUDE'
              )
            "
          >
            <el-row class="round red">{{ bidding }} </el-row>
            <el-row class="mt-15">待确价（单）</el-row>
          </li>
          <!-- 我的委托单 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/goods/entrust-client-list?',
                'WODEWEITUODAN_WEITUODANLIEBIAO'
              )
            "
          >
            <el-row class="round yellow">{{ send_sum }}</el-row>
            <el-row class="mt-15">待派车（吨）</el-row>
          </li>
          <!-- 运单列表 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/waybill/waybill-list?pay_status=PaymentEnd&position_status=PositionFailure&receipt_status=UN_LOAD',
                'YUNDANGENZONG_YUNDANLIEBIAO'
              )
            "
          >
            <el-row class="round perpur">{{ location_anomaly_sum }}</el-row>
            <el-row class="mt-15">追踪异常（单）</el-row>
          </li>
          <!-- 财务管理---运费支付--运单支付页面 -->
          <li
            class="center hand"
            @click="
              toUrl('/settle/waybill-pay-list?num=0', 'CAIWUGUANLI_YUNFEIZHIFU')
            "
          >
            <el-row class="round green">{{ freight }}</el-row>
            <el-row class="mt-15">待支付运费（元）</el-row>
          </li>
          <!-- 财务管理---申请开票--物流辅助费支付页面 -->
          <li
            class="center hand"
            @click="
              toUrl('/settle/waybill-pay-list?num=1', 'CAIWUGUANLI_YUNFEIZHIFU')
            "
          >
            <el-row class="round green">{{ assistance_fee }}</el-row>
            <el-row class="mt-15">待支付辅助费（元）</el-row>
          </li>
          <!-- <li class="center hand" @click="toUrl('/settle/ticket-apply-list','CAIWUGUANLI_SHENQINGKAIPIAO')">
            <el-row class="round blue">{{received_weight}}</el-row>
            <el-row class="mt-15">代开票（元）</el-row>
          </li> -->
        </ul>
      </el-row>
    </el-row>
    <el-row class="box main-bd">
      <el-row class="list-title clearfi">
        <el-row class="sum fl">
          <span class="grayColor">
            委托总量：
            <em
              class="mainColor"
              v-for="(item, index) in data.goods_total_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }}</em
            >
          </span>
          <span class="grayColor" style="margin-left: 20px">
            承运总量：
            <!-- <em class="mainColor">{{data.carrying_amount}}</em> 吨 -->
            <em
              class="mainColor"
              v-for="(item, index) in data.carrying_amount_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }}</em
            >
          </span>
          <span class="grayColor" style="margin-left: 20px">
            库存总量：
            <em
              class="mainColor"
              v-for="(item, index) in data.inventory_amount_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }}</em
            >
            <!-- <em class="mainColor">{{data.inventory_amount}}</em> 吨 -->
          </span>
        </el-row>
        <el-button
          class="fr"
          type="primary"
          @click="toUrl('/goods/choice-send')"
          v-auth="'WOYAOFABU'"
          >我要发布</el-button
        >
      </el-row>
      <el-table
        class="nth"
        :empty-text="empty_text"
        border
        :data="data.content"
      >
        <el-table-column min-width="110" label="委托单号">
          <template slot-scope="scope">
            <p
              v-if="scope.row.number && !scope.row.entrust_code"
              style="font-size: 12px"
            >
              自编号：{{ scope.row.number }}
            </p>
            <p v-if="scope.row.superior_entrust_code" style="font-size: 12px">
              {{ scope.row.superior_entrust_code }}
            </p>
            <span
              class="link mainColor"
              @click="
                toUrl(
                  '/goods/entrust-client-details?pid=' + scope.row.pid,
                  'WODEWEITUODAN_WEITUODANLIEBIAO_WEITUODANXIANGQING'
                )
              "
              >{{ scope.row.entrust_code }}</span
            >
            <p v-if="scope.row.commission_id !== null">
              欧冶委托单号：{{ scope.row.commission_id }}
            </p>
            <p v-if="scope.row.operator">操作员：{{ scope.row.operator }}</p>
          </template>
        </el-table-column>
        <el-table-column label="承运方" prop="carriage_name" />
        <el-table-column min-width="140" label="线路">
          <template slot-scope="scope">
            <el-row v-if="scope.row.loading_address_province">
              <i class="iconfont icon-icon48 mainColor"></i
              >{{ scope.row.loading_address_province }}/{{
                scope.row.loading_address_city
              }}/{{ scope.row.loading_address_area }}</el-row
            >
            <el-row v-if="scope.row.unloading_address_province">
              <i class="iconfont icon-icon48 darkColor"></i
              >{{ scope.row.unloading_address_province }}/{{
                scope.row.unloading_address_city
              }}/{{ scope.row.unloading_address_area }}</el-row
            >
          </template>
        </el-table-column>
        <el-table-column label="委托量" prop="goods_total" width="70" />
        <el-table-column label="承运量" prop="carrying_amount" width="70" />
        <el-table-column label="库存量" prop="inventory_amount" width="70" />
        <el-table-column label="运输状态" prop="conveying_state_text" />
        <el-table-column label="创建日期" prop="create_time" min-width="110" />
        <el-table-column label="操作" min-width="120" v-if="ifOperation">
          <template slot-scope="scope" v-if="scope.row.operator">
            <!-- <el-button type="text" @click="toUrl('/goods/entrust-send?pid='+ scope.row.pid)" v-if="scope.row.conveying_state == 'NOT_BOUND'">编辑</el-button> -->
            <el-button
              type="text"
              @click="
                toUrl(
                  '/goods/entrust-send?pid=' +
                    scope.row.pid +
                    '&num=' +
                    2 +
                    '&state=' +
                    scope.row.conveying_state
                )
              "
              v-if="scope.row.isEdit"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="
                toUrl('/goods/entrust-send?pid=' + scope.row.pid + '&num=' + 1)
              "
              v-if="scope.row.isRestart"
              >重新委托</el-button
            >
            <el-button
              type="text"
              @click="cancelEntrust(scope)"
              v-if="scope.row.isCancel"
              >取消委托</el-button
            >
            <el-button type="text" @click="deleteItem(scope.row.pid)"
              >删除</el-button
            >
            <el-button
              type="text"
              @click="endItem(scope.row.pid)"
              v-if="scope.row.isEnd"
              >终结委托单</el-button
            >
            <el-popover
              v-if="scope.row.entrust_state == 'Failure'"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="causeContent"
              @show="cancelCause(scope.row.pid)"
              style="margin-left: 10px"
            >
              <span slot="reference" class="mainColor">取消成功</span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-button
      type="primary"
      round
      class="baojiaBtn0"
      @click="toUrl('/ofer/ofer-list')"
      >天天报价</el-button
    >
    <el-button
      type="primary"
      round
      class="baojiaBtn"
      @click="toUrl('/ofer/enquiry-list')"
      >一键询价</el-button
    >
    <el-dialog title="取消委托" :visible.sync="dialogVisible" class="dialog-sm">
      <el-form :model="dialogData" label-width="100px">
        <el-form-item label="取消委托理由">
          <el-select placeholder="请选择" v-model="dialogData.cancel_cause">
            <el-option label="延期发货" value="DelayTheDelivery"></el-option>
            <el-option label="计划取消" value="PlansToCancel"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注意：" class="tip">
          <span
            >已派车的运单不受影响，但所指派的承运方将无法再进行派车以及其他操作</span
          >
        </el-form-item>
      </el-form>
      <el-row class="btn-group sm">
        <el-button type="primary" @click="dialogSubmit">确 定</el-button>
        <el-button type="info" @click="dialogCancel">取 消</el-button>
      </el-row>
    </el-dialog>
  </el-row>
</template>
<script>
import { isSuccess, checkCode } from "@/assets/js/utils";
import { regionDataPlus, CodeToText } from "@/assets/js/app";
export default {
  data() {
    return {
      data: {
        content: [],
      },
      causeContent: "",
      dialogVisible: false,
      empty_text: "数据更新中，请稍后",
      search: {
        value2: "",
        loading_address_province: "",
        loading_address_city: "",
        loading_address_area: "",
        unloading_address_province: "",
        unloading_address_city: "",
        unloading_address_area: "",
        carriage_name: null,
        conveying_state: "",
        order_status: "all",
        entrust_code: "",
        create_time_begin: "",
        create_time_finish: "",
        paging: {
          page_size: 10,
          total: 0,
          pages: 0,
          page_num: 1,
        },
      },
      dialogData: {
        pid: "",
        cancel_cause: "",
      },
      bidding: null,
      send_sum: null,
      location_anomaly_sum: null,
      unclosed_weight: null,
      received_weight: null,
      freight: null,
      assistance_fee: null,
      ifOperation: true,
    };
  },
  created() {
    this.loadList();
    this.ifOperation = checkCode(
      "WODEWEITUODAN_WEITUODANLIEBIAO_WEITUODANXIANGQING"
    );
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.loadList();
        }
      },
      deep: true,
    },
  },
  methods: {
    loadList() {
      // 待确价
      api("indexsum.confirm.bidding.sum").then((res) => {
        let data = isSuccess(res);
        this.bidding = data;
      });
      // 待派车
      api("indexsum.entrust.send.sum").then((res) => {
        let data = isSuccess(res);
        this.send_sum = Math.floor(data);
      });
      // api('indexsum.unclosed.waybill.weight').then(res => {
      //   let data = isSuccess(res)
      //   this.unclosed_weight = Math.floor(data)
      // })
      // 追踪异常
      api("indexsum.waybill.location.anomaly").then((res) => {
        let data = isSuccess(res);
        this.location_anomaly_sum = data;
      });
      // 待支付-运费
      api("waybill.sum.payable.amount", { payment_status: "AwaitPay" }).then(
        (res) => {
          let data = isSuccess(res);
          this.freight = Math.floor(data.payable_amount + data.service_amount);
        }
      );
      // 待支付-物流辅助费
      api("indexsum.waybill.subsidiary.sum").then((res) => {
        let data = isSuccess(res);
        this.assistance_fee = Math.floor(data);
      });
      this.search.paging.page_size = 1000000;
      api("entrust.entrust.list.query", this.search).then((res) => {
        let data = isSuccess(res);
        this.data = data;
        this.data.content = data.entrust_list.slice(0, 9);
        this.page_total = res.data_total;
        if (this.data.content.length == 0) {
          this.empty_text = "暂无数据";
        }
        this.data.content = this.data.content.map((item) => {
          // item.num = 0
          item.isCancel = false;
          item.isEdit = true;
          item.isRestart = false;
          if (item.conveying_state == "OUT_WAREHOUSE") {
            item.isEdit = true;
          }
          if (item.entrust_state == "Failure") {
            item.isEdit = false;
          }
          if (item.entrust_state == "Created") {
            item.isCancel = true;
          }
          if (item.entrust_state == "PortionWaybill") {
            item.isRestart = true;
            // item.num = 1
          }
          if (item.entrust_state == "IntermodalTransport") {
          }
          if (item.conveying_state == "NOT_BOUND") {
            item.isEnd = false;
          } else {
            if (
              item.entrust_state == "EntirelyWaybill" ||
              item.entrust_state == "PortionWaybill" ||
              item.entrust_state == "Bidding" ||
              item.entrust_state == "Entrust" ||
              item.entrust_state == "IntermodalTransport"
            ) {
              item.isEnd = true;
            }
          }
          return item;
        });
        this.search.paging.total = res.data_total;
      });
    },
    //取消委托原因
    cancelCause(pid) {
      api("entrust.cancel.cause.query", { id: pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.causeContent = `取消原因：${data.cancel_cause_enum_text}`;
        }
      });
    },
    //终结委托单
    endItem(pid) {
      api("entrust.finish.order.entrust.update", { id: pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          alert(res.msg);
          this.loadList();
        }
      });
    },
    //取消委托单
    cancelEntrust(scope) {
      this.dialogVisible = true;
      this.dialogData.pid = scope.row.pid;
    },
    dialogSubmit() {
      api("entrust.cancel.entrust.update", this.dialogData).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.dialogVisible = false;
          this.loadList();
          setTimeout(function () {
            alert(res.msg);
          }, 200);
        } else {
          alert(res.msg);
        }
      });
    },
    dialogCancel() {
      this.dialogVisible = false;
      this.dialogData.id = "";
      this.dialogData.cancel_cause = "";
    },

    //删除委托单
    deleteItem(pid) {
      if (confirm("确认删除")) {
        api("entrust.entrust.delete", { id: pid }).then((res) => {
          let data = isSuccess(res);
          this.loadList();
          /* this.$message({
              type: 'success',
              message: res.msg
          }) */
          alert(res.msg);
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.baojiaBtn {
  position: absolute;
  top: 55%;
  right: -10%;
  height: 38px;
}
.baojiaBtn0 {
  position: absolute;
  top: 50%;
  right: -10%;
  height: 38px;
}
.my-sum {
  position: absolute;
  top: 41px;
  left: 30%;
}
.list-title {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.list-nav {
  border: 1px solid #e5e5e5;
  border-bottom: none;
  margin-right: 10px;
}
.list-nav li {
  float: left;
  width: 170px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  background: #f9f9f9;
  cursor: pointer;
}
.list-nav li.active {
  color: #fff;
  background: #cc0816;
}
.list-nav li:hover {
  color: #fff;
  background: #cc0816;
}
.yujing {
  height: 260px;
  background: #fff;
  margin-bottom: 30px;
  padding: 30px;
}
.center {
  text-align: center;
  float: left;
  // margin-right: 9%;
}
</style>



// WEBPACK FOOTER //
// src/views/index-entrust.vue